// extracted by mini-css-extract-plugin
export default {"dataCell":"CellWithWasLabel_dataCell__y+14K","wasStatus":"CellWithWasLabel_wasStatus__RHNAr"};